(function(window, overwatch){
	/*
		Hero selection functionality.
	*/
	var HeroSelect = function() {
		var currentHero;

		function init(options) {
			var $section 			= options.$section;
			var $overlay 			= options.$overlay;
			var $overlayText 		= options.$overlayText;
			var $overlayTextBorder 	= options.$overlayTextBorder;
			var $overlayWrap        = options.$overlayWrap;
			var $selectionWrap 		= options.$selectionWrap;
			var classLoaded 		= options.classLoaded;

			// Handle character hover event.
			$selectionWrap.on("mouseenter", ".selection-link", function(event) {
				var $this = $(this);
				var heroSlug = $this.data("hero-slug");
				var heroRole = $this.data("hero-role");
				var heroRoleId = $this.data("hero-role-id");
				var heroOverlayImage = $this.data("hero-overlay");

				//if (heroSlug != "undefined" && Core.userAgent === "web"){
				if (heroSlug != "undefined" && !overwatch.util.mobile()){

					$section.addClass("overlay-ready");
					$overlay.attr("style","");
					$overlayWrap.addClass("loading");

					HeroSelect.currentHero = heroSlug;

					preloadImage(heroOverlayImage, heroSlug, function(preloadedImage, preloadedHero) {
						if(HeroSelect.currentHero == preloadedHero) {
							$overlayWrap.removeClass("loading");
							$overlay.attr("style", 'background-image:url(' + preloadedImage + ')');
						}
					});

					$section.addClass(classLoaded);

					// Define character description text.
					$overlayText.find("h2").html(heroSlug);
					$overlayText.find("i").attr("class","icon role-" + heroRoleId);
					$overlayText.find("p").text(heroRole);
					$overlayText.addClass(classLoaded);
					$overlayTextBorder.addClass(classLoaded);
				}

			});

			// Handle character un-hover event.
			$selectionWrap.on("mouseleave", ".selection-link", function() {
				$section.removeClass(classLoaded);
				$overlayText.removeClass(classLoaded);
				$overlayTextBorder.removeClass(classLoaded);
				$overlayWrap.removeClass("loading");
			});

			// Handle removal of highlighted portrait animation
			$(".selection-item.is-highlighted").each(function(i, highlightedItem) {
				var $highlightedItem = $(highlightedItem);

				// .selection-link is the targeted hoverable element
				$highlightedItem.find(".selection-link").each(function(i, selectionLink) {
					var $highlightedParent = $highlightedItem;

					// Need to remove the highlighted class of the parent .selection-item when
					// its child .selection-link is hovered on
					$(selectionLink).on("mouseenter", function(event) {
						$highlightedParent.removeClass("is-highlighted");
						$(this).off("mouseenter");
					});
				});
			});
		}

		/**
		 * Starts image preload
		 */
		function preloadImage(loadingImagePath, id, callback) {

			var tempImage = new Image();

			$(tempImage).load(function(){
				if(callback){
					callback(tempImage.src, id)
				}
			});

			tempImage.src = loadingImagePath;
		}

		return {
			init: init
		};
	}();

	window.HeroSelect = HeroSelect;
}(window, window.overwatch));